var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "padding-y-5xl inverted",
      staticStyle: { "background-color": "var(--fa-dk-navy)" },
      attrs: { id: "logos" },
    },
    [
      _c("div", { staticClass: "container text-center" }, [
        _c(
          "h2",
          {
            staticClass: "text-uppercase size-md",
            staticStyle: {
              "letter-spacing": "var(--letter-spacing-3xl)",
              "font-weight": "var(--font-weight-black)",
              color: "var(--fa-yellow)",
            },
          },
          [
            _vm._v(
              "\n      The Web's Default Icon Set, Used on Over 200 Million Sites\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "display-flex align-middle align-center align-around flex-wrap size-lg laptop:size-xl",
          },
          _vm._l(_vm.iconGroup, function ([url, icon, title, size]) {
            return _c("div", { key: title, staticClass: "margin-top-xl" }, [
              _c(
                "a",
                {
                  staticClass: "padding-x-sm",
                  staticStyle: {
                    "--link-color": "var(--white)",
                    "--link-hover-color": "var(--fa-blue)",
                  },
                  attrs: {
                    href: url,
                    "aria-label": title,
                    target: "_blank",
                    rel: "nofollow",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$posthog.capture("home:logo_link_click", {
                        logo: title,
                      })
                    },
                  },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: icon, title: title, size: size },
                  }),
                ],
                1
              ),
            ])
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }